var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/company-notice.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-5971ed62!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/company-notice.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyNotice.vue
// module id = 608
// module chunks = 1